import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import {trigger, transition, style, animate, state} from '@angular/animations';
import { DailyProdHighlights,MSCToken, DPHToken, DailyToken, DailyTokenItem, DPHDayToken, Plan, MaterialShortage, GenResponse } from '../../shared/misc-classes';
import { NotificationsService } from 'angular2-notifications';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { ErrorPopupComponent } from '../../common/error-popup/error-popup.component';

@Component({
  selector: 'app-prod-high',
  templateUrl: './prod-high.component.html',
  styleUrls: ['./prod-high.component.css'],
  animations: [
    trigger(
      'myAnimation',
      [
        transition(
        ':enter', [
          style({transform: 'translateX(100%)', opacity: 0}),
          animate('500ms', style({transform: 'translateX(0)', 'opacity': 1}))
        ]
      ),
      transition(
        ':leave', [
          style({transform: 'translateX(0)', 'opacity': 1}),
          animate('500ms', style({transform: 'translateX(100%)', 'opacity': 0})
          
          )]
      )]
    )
  ]
})
export class ProdHighComponent implements OnInit {

  editToken: string = '';
  editHeader: string = '';
  editText: string = '';
  editType: string = '';
  editParam1: any;
  editParam2: any;
  moduleKeyName: string = "daily_prod_high";
  currMonthDtObj: Date = new Date();
  shortageFlag:boolean = false;
  severityFlag:boolean = false;
  isNewRecord:boolean = false;
  prevValue:string = 'no';

  editRow: DPHToken;


  dProdHighObj: DailyProdHighlights;
  dDPHDayTokenObj: DPHDayToken;


  isLoading: boolean = false;
  isLoaded: boolean = false;
  isFailed: boolean = false;
  failMessage: string = '';

  selView: number = 1;
  areChangesMade: boolean = false;

  planObj: Plan;
  btnName: string = '';
  mId: string = "7371ba17-9f08-4da0-6fc0-f2f7c8686504";
  hasmodaccess: boolean = false;
  daywiseItemList: Array<DailyToken>;

  @ViewChild('childModal') public childModal: ModalDirective;
  @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;

  constructor(public _dataService: DataService,
    private _activatedRoute: ActivatedRoute, private _notify: NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "Production Plan";
    this._activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['month']) {
        this.currMonthDtObj = new Date(parseInt(params['month']));
      }
      this.loadMonthData();
      this.loadPlan();
    });
        
  }

  checkModAccess(): boolean {
    if (this._dataService.mAccess(this.mId) == true) {
      this.hasmodaccess = true;
    }
    else {
      this.hasmodaccess = false;
    }
    return this.hasmodaccess;
  }
  hasEditAccess(_pid: string) {
    return this._dataService.hasEditAccess(this.mId, _pid);
  }
  hasReadAccess(_pid: string) {
    return this._dataService.hasReadAccess(this.mId, _pid);
  }

  formatMonth(_dateObj: Date): string {
    if (_dateObj) {
      return GenService.getDateFormatStr(_dateObj, "MMM-YYYY");
    }
    return '-';
  }
  shortageChanged(val) {
    if(this.isNewRecord){
      if (val == 'yes') {
        this.shortageFlag = true;
      }else{
        this.editRow.severityValue = null;
        this.editRow.shortageNotes = null;
        this.severityFlag = false;
        this.shortageFlag = false;
      }
    }else{
      if(val == 'no'){
        this.editRow.severityValue = null;
        this.editRow.shortageNotes = null;
        this.severityFlag = false;
        this.shortageFlag = false;
      }
      else if(val == 'yes' && this.prevValue == 'no'){
        this.shortageFlag = true;
      }
      else{
        this.severityFlag = true;
      }
    }
  }
  severityClicked(editRow,option){
    this.severityFlag = true;  
      this.shortageFlag = false;      
      this.editRow.severityValue = option;
     // this.loadShortageData();
  }
  // loadShortageData() {
  //   if (this.editRow.isShortageLoaded == false) {
  //     this._dataService.loadShortageData(this.editRow.materialShortageIds).subscribe((_msArray: Array<MSCToken>) => {
  //       this.editRow.materialShortageData = _msArray;
  //     })
  //   }
  // }
  loadMonthData() {
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;
    this._dataService.loadDailyProdHighlights(this.currMonthDtObj).subscribe((_dailyProdHigh: DailyProdHighlights) => {
      if (_dailyProdHigh != null) {
        this.dProdHighObj = _dailyProdHigh;
        this.loadDateData();

        let _tmpDailyTokenList: Array<DailyToken> = [];
        for (var i = 0; i < this.dProdHighObj.dayTokens.length; i++) {
          let _tmpDate:Date = this.dProdHighObj.dayTokens[i].selDate;
          let _tmpDailyTokens:Array<DailyTokenItem> = [];
          
          let _indexer:number = 0;
          this.dProdHighObj.dayTokens[i].dateTokens.forEach((_tmpObj:DPHToken) => {
            _tmpDailyTokens.push(new DailyTokenItem( this.getDisplayTokenName(_tmpObj.productId,_tmpObj.quantity), this.getIdObj(_tmpDate,_indexer),''));
            _indexer++;
          });
          _tmpDailyTokenList.push(new DailyToken(_tmpDate, _tmpDailyTokens));
        }

        this.daywiseItemList = _tmpDailyTokenList;
        this.isLoaded = true;
        this.isLoading = false;
        this.isFailed = false;
      }
      else {
        this.daywiseItemList = null;
        this.isLoaded = false;
        this.isLoading = false;
        this.isFailed = true;
        this.failMessage = "Failed to get data from database, try again";
      }
    });
  }

  private getDisplayTokenName(_prodId:string,_quantity:number){
    return this._dataService.getProductName(_prodId) + ' ('+_quantity+')';
  }
  private getIdObj(_selDate:Date,_itemIndex:number){
    return {"selDate":_selDate,"rowIndex":_itemIndex}
  }
  ItemSelected(_evntObj){
    this.selView = 1;
    this.currMonthDtObj.setDate(_evntObj.selDate.getDate());
    this.loadDateData();
  }

  public showChildModal(_editToken: string, _param1: any, _param2: any): void {
    switch (_editToken) {
      case "rowedit": 
        this.btnName = "Done";
        this.editRow = _param1.cloneSelf();
        this.isNewRecord = false;
        this.prevValue = this.editRow.shortage;
        if (this.editRow.shortage == 'yes') {
          this.severityFlag = true;
          this.shortageFlag = false;
        //  this.loadShortageData();
        }else{
          this.severityFlag = false;
          this.shortageFlag = false;
        }
        this.editType = _editToken;
        this.editHeader = "Edit Production Plan (" + this.formatHeaderDate(this.dDPHDayTokenObj.selDate) +")";
        break;
      case "rownew":
        this.btnName = "Done";
        var _dt = new Date();
        this.editRow = new DPHToken(GenService.getGUID(), null,null,null,0,null,null,new Date(_dt).getTime(),null,null);
        this.editType = _editToken;
        this.isNewRecord = true;
        this.severityFlag = false;
        this.shortageFlag = false;
        this.editHeader = "Add Production Plan (" + this.formatHeaderDate(this.dDPHDayTokenObj.selDate) +")";
        break;
      case "selplan":
        this.btnName = 'Save'
        this.editText = this.planObj.description;
        this.editType = 'text';
        this.editHeader = "Edit Plan";
        break;
  }
  this.editParam1 = _param1;
  this.editParam2 = _param2;
  this.editToken = _editToken;
  this.childModal.show();
}


  dataEdited() {
    switch (this.editToken) {
      case "rowedit":
        this.editParam1.productId = this.editRow.productId;
        this.editParam1.customerId = this.editRow.customerId;
        this.editParam1.quantity = this.editRow.quantity;
        this.editParam1.shortage = this.editRow.shortage;
        this.editParam1.status = this.editRow.status;
        this.editParam1.productType = this._dataService.getProductTypeBasedOnProductId(this.editRow.productId)
        // this.editParam1.materialShortageIds = this.editRow.materialShortageIds;
        // this.editParam1.materialShortageData = this.editRow.materialShortageData;
        this.editParam1.shortageNotes = this.editRow.shortageNotes;
        this.editParam1.severityValue = this.editRow.severityValue;
        this.areChangesMade = true;
        break;
      case "rownew":
        let _tempShortageIds = [];
        let _newToken:DPHToken = new DPHToken(this.editRow.rowId, this.editRow.productId,this._dataService.getProductTypeBasedOnProductId(this.editRow.productId), this.editRow.customerId,
        this.editRow.quantity, this.editRow.shortage,this.editRow.status,this.editRow.creationDate,this.editRow.shortageNotes,this.editRow.severityValue);
        // _newToken.materialShortageData = this.editRow.materialShortageData;
        this.dProdHighObj.addDateToken(new Date(this.currMonthDtObj),_newToken);
        this.areChangesMade = true;
        break;
      case "selplan":
        this.dProdHighObj.plan = this.editText;
        this.planObj.description = this.editText;
        this.planObj.monthDateNum = this.currMonthDtObj.getTime();
        this.savePlan();
        break;
    }
    this.hideChildModal();
  }
  loadPlan(){
    this._dataService.loadPlan(this.currMonthDtObj).subscribe((_dailyProdHigh: Plan) => {
      if (_dailyProdHigh != null) {
        this.planObj = _dailyProdHigh;
      }
    });
  }
  savePlan() {
    this._dataService.savePlan(this.planObj).subscribe((resp: GenResponse) => {
      if (resp.status == "FAIL") {
        if (resp.errorCode == DataService.staleDataCode) {
          this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
        } else {
          this._notify.error('Failure', resp.details, this._dataService.failureOptions);
        }
      }
      else {
        this._notify.success('Success', resp.details, this._dataService.successOptions);
        this.loadMonthData();
        this.loadPlan();
      }
    });
  }
  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }

  getProductName(_prodId: string): string {
    if (_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }
  getCustomerName(_custId: string): string {
    if (_custId)
      return this._dataService.getCustomerName(_custId);
    return '';
  }
  getShortage(_custId: string): string {
    if (_custId)
      return this._dataService.getShortage(_custId);
    return '';
  }
  getStatus(_st:string):string{
    if(_st == "forwarded"){
      return "Forwarded";
    }
    if(_st){
      return this._dataService.getRecordStatus(_st)
    }
    return ''
  }
  getData(option) {
    if (option) return option
    return ''
  }

  parseDate(dateString: string): Date {
    if (dateString) {
      return new Date(dateString);
    } else {
      return null;
    }
  }
  public prevMonthSel(): void {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
    this.loadPlan();
  }
  nextMonthSel() {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
    this.loadPlan();
  }
  prevDateSel():void{
    if(this.currMonthDtObj.getDate() > 1){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()-1);
      this.loadDateData();
    }
  }
  nextDateSel():void{
    var _tmpLastDayOfMonth:Date = new Date(this.currMonthDtObj.getFullYear(),this.currMonthDtObj.getMonth()+1,0);
    if(this.currMonthDtObj.getDate() < _tmpLastDayOfMonth.getDate()){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()+1);
      this.loadDateData();
    }
  }

  public hideChildModal(): void {
    this.childModal.hide();
  }

  public discardSaveData(): void {
    this.childModal.hide();
  }

  discardData(): void {
    this.loadMonthData();
    this.loadPlan();
  }

  validateData(): boolean {
    return true;
  }

  saveData(_sendMail: boolean): void {
    if (this.validateData() == true) {
      this._dataService.saveDailyProdHighlight(this.dProdHighObj, _sendMail)
        .subscribe((resp: GenResponse) => {
          if (resp.status == "FAIL") {
            if(resp.errorCode == DataService.staleDataCode){
              this.errorPopup.showErrorPopup("Stale Data",DataService.staleDateErrorMsg)
            }else{
              this._notify.error('Failure', resp.details, this._dataService.failureOptions);
            }
          }
          else {
            this._notify.success('Success', resp.details, this._dataService.successOptions);
            this.loadMonthData();
            this.loadPlan();
          }

        });
    }
  }
  
  public removeRecord( _tokenIndex:number) {
    this.dDPHDayTokenObj.removeToken(_tokenIndex);    
    this.areChangesMade = true;
  }

  loadDateData():void{
    let _tmpDPHDayToken:DPHDayToken = this.dProdHighObj.getDateToken(this.currMonthDtObj);
    if(_tmpDPHDayToken == null){
      this.dProdHighObj.addDateToken(this.currMonthDtObj);  
      _tmpDPHDayToken = this.dProdHighObj.getDateToken(this.currMonthDtObj);
    }
    this.dDPHDayTokenObj = _tmpDPHDayToken;
  }

  public getSelYear(): number {
    return this.currMonthDtObj.getFullYear();
  }
  public getSelMonth(): number {
    return this.currMonthDtObj.getMonth() + 1;
  }
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }
  calculate(name:string,dayTokens:Array<DPHToken>,_productTypeId:string = null){ 
    let array:Array<DPHToken>;
    if(_productTypeId){
      array = dayTokens.filter((_obj:DPHToken) => {
        return  this.isInProductname(_obj.productId,_productTypeId);
      });
    }
    else{
      array = dayTokens;
    }
    
    switch(name){
      case 'quantity':
        var QTY = 0
        for(var i=0;i<array.length;i++){
          if(array[i].quantity){
              QTY += Number(array[i].quantity);
          }
        }
        return QTY;
      }
}
isInProductname(_productId:string, _productTypeId:string){
  for(var i=0;i<this._dataService.products.length;i++){
    if(this._dataService.products[i].productId == _productId){
      if(this._dataService.products[i].productName == _productTypeId) 
          return true;
      else 
         return false;
    }
  }
}null
}


